<!--  -->
<template>
  <div>
    <!-- 阳光 -->
    <div class="optionbox">
      <div class="optiontext">推广类型：</div>
      <div>阅读页推广</div>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">渠道名称：</div>
      <el-input v-model="name" style="width:300px" placeholder="请输入内容" />
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">推广成本：</div>
      <el-input v-model="money" style="width:300px" placeholder="请输入内容" type="number" @blur="activegivemoney" />
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">渠道类型：</div>
      <el-radio-group v-model="qudaoradio">
        <el-radio :label="1">已认证</el-radio>
        <el-radio :label="2">未认证</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">导粉章节序号：</div>
      <el-input v-model="chapternum" style="width:300px" placeholder="示例：导粉章节设置为第8章，则输入数字8" type="number" @blur="chapternummoney" />
    </div>
    <div>
      <div style="margin-left:100px">
        <i class="el-icon-info" style="margin-right:5px" />建议【导粉章节序号】在【阅读原文章节】之后两章为优
      </div>
      <div style="margin-left:100px;margin-top:10px">
        <i class="el-icon-info" style="margin-right:5px" />导粉章节必须小于收费章节
      </div>
    </div>
    <el-button type="primary" @click="sumbit">确定</el-button>
    <!-- {{ objquery }} -->
  </div>
</template>

<script>
import { bookPlatformcreate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      objquery: {},
      name: '',
      money: '',
      qudaoradio: 1,
      chapternum: ''
    }
  },
  watch: {
    obj: {
      handler(newValue, oldValue) {
        console.log('111', newValue)
        this.objquery = newValue
        this.name = newValue.bookname + '-' + newValue.chaptername
      },
      deep: true
    }
  },
  created() {
    this.objquery = this.obj
  },
  mounted() {

  },
  methods: {
    activegivemoney() {
      // eslint-disable-next-line eqeqeq
      if (this.money < 0 && this.money != '') {
        this.money = 1
      }
    },
    chapternummoney() {
      // eslint-disable-next-line eqeqeq
      if (this.chapternum <= 0 && this.chapternum != '') {
        this.chapternum = ''
      }
      // 判断不能输入小数点
      const str = '' + this.chapternum
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.chapternum = 1
      }
    },
    async sumbit() {
      if (this.objquery.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.objquery.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.objquery.chapterid === null) {
        this.$message.error('请选择章节')
        return
      }
      if (this.name === '') {
        this.$message.error('请输入渠道名称')
        return
      }
      if (this.money === '') {
        this.$message.error('请输入推广成本')
        return
      }
      // if (this.chapternum === '') {
      //   this.$message.error('请输入导粉章节序号')
      //   return
      // }
      const data = await bookPlatformcreate({
        platform_id: this.objquery.platformvalue,
        template_data: {
          type: 1,
          book_id: this.objquery.bookid,
          chapter_id: this.objquery.chapterid,
          chapter_idx: this.objquery.chapteridx,
          chapter_name: this.objquery.chaptername,
          cost: this.money,
          name: this.name,
          wx_type: this.qudaoradio,
          guide_chapter_idx: this.chapternum,
          push: this.objquery.radio
        }
      })
      this.$emit('close')
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.optionbox{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext{
  width: 100px;
  text-align: right;
}

.demo-ruleForm /deep/ .el-input__inner{
  line-height: 1px !important;
}

/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
